/**
 * Calls for the portal login page.
 *
 * Uses plain fetch rather than @common/axios: that instance's interceptors depend on the
 * `globalReactFunctions` global set up by the authenticated app, which does not exist on this
 * public page.
 */

const postJson = async (url, body) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
    }

    return response.json();
};

export const portalLogin = (username, password, linkHash, recaptchaToken) =>
    postJson('/web/ui/portalAuth/public/login', {username, password, linkHash, recaptchaToken});

export const sendPortalResetPasswordEmail = (email, username, recaptchaToken) =>
    postJson('/web/ui/portalAuth/public/resetPasswordEmail', {email, username, recaptchaToken});
